import { useRef, useState, useEffect } from 'preact/hooks'

import Icon from '@/components/snippets/icon/icon'

import { SearchInput } from 'libs/searchspring/components/quick-search/SearchInput'
import { QuickSearchDropdown } from 'libs/searchspring/components/quick-search/QuickSearchDropdown'
import { SearchspringAutocompleteProvider } from 'libs/searchspring/fetchers/autocomplete'

function QuickSearch({ id = 'quick-search' }) {
  const searchInputRef = useRef()
  const [inputValue, setInputValue] = useState('')
  const [query, setQuery] = useState()
  const modalRef = useRef()
  const [redirect, setRedirect] = useState(false)

  const handleUpdateValue = (event) => {
    setInputValue(event.target.value)
  }

  const handleFocus = () => {
    if (modalRef.current) {
      modalRef.current.handleShow()
    }
  }

  const handleClose = () => {
    setInputValue('')
    if (searchInputRef.current) {
      searchInputRef.current.value = ''
    }
    if (modalRef.current) {
      modalRef.current.handleHide()
    }
  }

  const handleClear = () => {
    setInputValue('')
    if (searchInputRef.current) {
      searchInputRef.current.value = ''
    }
  }

  useEffect(() => {
    const timeout = setTimeout(() => {
      setQuery(inputValue)
    }, 400)
    return () => {
      clearTimeout(timeout)
    }
  }, [inputValue])

  return (
    <x-modal className="group/search group-data-visible/search:z-60 flex h-full items-center" data-id={id} data-body-lock ref={modalRef}>
      <div className="flex flex-row flex-nowrap group-data-visible/search:z-60 relative w-full px-1.25 pb-1 bg-brand-white lg:bg-transparent lg:px-0 lg:pb-0">
        <div className="relative flex-grow">
          <Icon id="magnifying-glass" className="absolute left-0.75 top-0.875 h-[15px] w-[15px]" />
          <SearchInput
            modalId={id}
            modalRole="open"
            ref={searchInputRef}
            redirect={redirect}
            onInput={handleUpdateValue}
            onFocus={handleFocus}
          />
          <span onClick={handleClear} className={`${inputValue?.length > 0 ? 'block' : 'hidden'} cursor-pointer absolute top-0.875 right-0.75 paragraph-xs text-neutral-primary`}>Clear</span>
        </div>
        <button
          className="group-data-visible/search:block hidden flex-shrink bg-black text-white p-0.75 ml-0.5"
          onClick={handleClose}
          aria-label="Close modal"
        >
          <Icon id="close" className="w-[15px] h-[15px]" />
        </button>
      </div>
      <div className="invisible group-data-visible/search:visible group-data-visible/search:opacity-100 opacity-0 group-data-visible/search:z-100 flex h-[calc(100vh-100%)] lg:h-fit w-full flex-col transition-all absolute left-0 top-[100%] lg:top-[calc(100%-4px)] border-t border-t-neutral-medium">
        <SearchspringAutocompleteProvider runOnMount={false} resultsPerPage={5}>
          <QuickSearchDropdown query={query} redirect={redirect} setRedirect={setRedirect} />
        </SearchspringAutocompleteProvider>
      </div>
      <button
        className="pointer-events-none fixed z-90 size-full cursor-n-resize bg-neutral-black/60 opacity-0 transition-all left-0 top-[79px] translate-y-1.875 group-data-visible/search:pointer-events-auto group-data-visible/search:lg:opacity-100"
        onClick={handleClose}
        aria-label="Close modal"
      ></button>
    </x-modal>
  )
}

export function WrappedQuickSearch({ id }) {
  return (
    <SearchspringAutocompleteProvider runOnMount={false}>
      <QuickSearch id={id} />
    </SearchspringAutocompleteProvider>
  )
}
